// store/productGroupSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllProductGroups } from '../data/productsData';

// Async thunk for fetching product groups (frontpage data)
export const fetchProductGroups = createAsyncThunk(
  'productGroups/fetch',
  async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // Return only what frontpage needs
    return getAllProductGroups();
  }
);

const productGroupSlice = createSlice({
  name: 'productGroups',
  initialState: {
    groups: [],
    imagePathGroup: "./pimages/img_axl/02_products", //add
    loading: false,
    error: null,
    activeGroups: [],
    isMobile: false,
    pdfDownloads: {}
  },
  reducers: {
    setActiveGroups: (state, action) => {
      state.activeGroups = action.payload;
    },
    
    toggleProductGroup: (state, action) => {
      const groupId = action.payload;
      if (state.activeGroups.includes(groupId)) {
        state.activeGroups = state.activeGroups.filter(id => id !== groupId);
      } else {
        state.activeGroups.push(groupId);
      }
    },
    
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
      // Auto-expand all groups on mobile
      if (state.isMobile && state.groups.length > 0) {
        state.activeGroups = state.groups.map(g => g.id);
      } else {
        state.activeGroups = [];
      }
    },
    
    trackPdfDownload: (state, action) => {
      const { groupId, productName } = action.payload;
      if (!state.pdfDownloads[groupId]) {
        state.pdfDownloads[groupId] = [];
      }
      state.pdfDownloads[groupId].push({
        productName,
        timestamp: new Date().toISOString()
      });
    },
    
    clearGroups: (state) => {
      state.groups = [];
      state.activeGroups = [];
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = action.payload;
        // Auto-expand all on mobile
        if (state.isMobile) {
          state.activeGroups = action.payload.map(g => g.id);
        }
      })
      .addCase(fetchProductGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Selectors
export const selectProductGroups = (state) => state.productGroups.groups;
export const selectProductGroupsLoading = (state) => state.productGroups.loading;
export const selectProductGroupsError = (state) => state.productGroups.error;
export const selectActiveGroups = (state) => state.productGroups.activeGroups;
export const selectIsMobile = (state) => state.productGroups.isMobile;
export const selectPdfDownloads = (state) => state.productGroups.pdfDownloads;

export const selectImagePathGroup = (state) => state.productGroups.imagePathGroup;

// Export actions
export const { 
  setActiveGroups, 
  toggleProductGroup, 
  setIsMobile,
  trackPdfDownload,
  clearGroups
} = productGroupSlice.actions;

export default productGroupSlice.reducer;